import React from 'react';
import { FormattedMessage } from 'react-intl';

import { TextButtonRegularSmall as TextButton } from '@xingternal/malt-button';
import { H, P } from '@xingternal/malt-typography';

import ModalInfo from '../../../Components/ModalInfo/ModalInfo';

import messages from './messages';

const FileUploadExpirationModal = () => (
  <ModalInfo>
    {(openModal, renderModalContent) => (
      <>
        <br />
        <TextButton onClick={openModal} noPadding>
          <FormattedMessage {...messages.fileUploadExpiration} />
        </TextButton>
        {renderModalContent(
          <>
            <H level={1}>
              <FormattedMessage {...messages.fileUploadExpirationTitle} />
            </H>
            <P>
              <FormattedMessage {...messages.fileUploadExpirationParagraph} />
            </P>
          </>
        )}
      </>
    )}
  </ModalInfo>
);

export default FileUploadExpirationModal;
